import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { dogbreeds } from "../assets/inc/breeds";
import { catbreeds } from "../assets/inc/catBreeds";
import { setTextAnswerChoice } from "../state/domains";
import { Grid } from "@mui/material";
import { connect } from "react-redux";
import Box from "@mui/material/Box";

const BreedChoices = props => {
  const { card, _setAnswerChoice, petType } = props;
  const { question, qnId, value } = card;
  // const [inputValue, setInputValue] = useState("");

  //const initialValue = useRef(value);
  const breeds = petType === "cat" ? catbreeds : dogbreeds;
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        md={4}
        sx={{ "padding-top": "2vh", "padding-bottom": "2vh" }}>
        <Box
          sx={{
            display: "flex",
            fontWeight: "bold",
            boxShadow: 1,
            borderRadius: 2,
            "background-color": "#e7ede0",
            p: 1,
          }}>
          {" "}
          {question}:{" "}
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ "padding-bottom": "2vh", "padding-left": "3vh", m: 1 }}>
        <Autocomplete
          id="breed"
          options={breeds}
          getOptionLabel={option => option.name}
          renderInput={params => <TextField {...params} label="" />}
          style={{ width: 270 }}
          value={breeds.find(breed => breed.id === value)}
          onChange={(_event, newBreed) => {
            if (!newBreed) _setAnswerChoice("0", qnId);
            else _setAnswerChoice(newBreed.id, qnId);
          }}
          sx={{ width: "inherit" }}
          /*         inputValue={inputValue}
              onInputChange={(event, newInputValue,clear) => {
          if (newInputValue === "" || newInputValue === "No Choice") {
            _setAnswerChoice("0", qnId);
            newInputValue = breeds.find(breed => breed.id === "0");
          }
          setInputValue(newInputValue);
        }}  */
        />
      </Grid>
    </Grid>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    _setAnswerChoice: (textValue, questionId) =>
      dispatch(setTextAnswerChoice(textValue, questionId)),
  };
}

export default connect(null, mapDispatchToProps)(BreedChoices);
